import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";

const PlantPicker2 = ({ onChange, value }) => {
	const [options, setOptions] = useState([]);
	const [disabled, setDisabled] = useState(true);
	const [currentValue, setCurrentValue] = useState(value);

	useEffect(() => {
		getPlants();
	}, []);

	const onChangePlant = (value) => {
		setCurrentValue(value.value);
		onChange(value);
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];

				data.payload
					.filter((item) => item.name !== "Laredo")
					.map((item) => {
						list.push({
							value: item._id,
							label: item.name,
						});
					});
				setOptions(list);
				setDisabled(false);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	return (
		<Select
			size="large"
			options={options}
			value={options.filter((o) => {
				return o.value === currentValue;
			})}
			onChange={onChangePlant}
			labelInValue={true}
			style={{ width: "100%" }}
			loading={disabled}
			disabled={disabled}
		/>
	);
};

export default PlantPicker2;
